module.exports = __webpack_public_path__ + "images/people/man-woman-IT@1x-195efe9c4e237f9a08e1736a74ef29f7.webp";